import { Box } from '@mui/material'
import styles from './index.module.scss'

/**
 * Outer column for an active thread: max 920px, fills main scroll area height.
 * @param {{ children: React.ReactNode }} props
 */
function ChatConversationLayout({ children, className }) {
  return (
    <Box component="div" className={[styles.shell, className].filter(Boolean).join(' ')}>
      {children}
    </Box>
  )
}

export default ChatConversationLayout
